__turbopack_context__.v({
  "colorScheme--alert": "si7KeW_colorScheme--alert",
  "colorScheme--success": "si7KeW_colorScheme--success",
  "colorScheme--warning": "si7KeW_colorScheme--warning",
  "container": "si7KeW_container",
  "heading": "si7KeW_heading",
});
